import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["overlay"];

  open() {
    if (!this.hasOverlayTarget) return;

    this.overlayTarget.hidden = false;
    this.overlayTarget.setAttribute("aria-hidden", "false");
    document.body.classList.add("cut-v2-modal-open");
  }

  close() {
    if (!this.hasOverlayTarget) return;

    this.overlayTarget.hidden = true;
    this.overlayTarget.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cut-v2-modal-open");
  }

  backdropClose(event) {
    if (event.target === this.overlayTarget) {
      this.close();
    }
  }

  escape(event) {
    if (event.key === "Escape" && this.hasOverlayTarget && !this.overlayTarget.hidden) {
      this.close();
    }
  }
}
